/* G Decor Mobile Navigation Drawer */
(function(){
  var drawer = document.getElementById('gd-mob-drawer');
  if(!drawer) return;

  function open(){
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('gd-mob-drawer-open');
  }
  function close(){
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('gd-mob-drawer-open');
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-gd-mob-open]')){
      e.preventDefault();
      open();
      return;
    }
    if(e.target.closest('[data-gd-mob-close]')){
      e.preventDefault();
      close();
      return;
    }
    // Close drawer when a regular link inside it is tapped
    var link = e.target.closest('.gd-mob-drawer__panel a');
    if(link && !link.hasAttribute('data-gd-mob-keep')){
      // small delay so the link navigates first
      setTimeout(close, 50);
    }
  });

  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
})();
